import React from "react";
import "./Loader.css";

function Loader({
  inline = false,
  size = "large",
  text = "Loading...",
  color = "primary",
}) {
  const spinnerClass = `custom-spinner custom-spinner-${size} custom-spinner-${color}`;
  const textClass = `custom-loader-text custom-loader-text-${
    size === "small" ? "small" : "large"
  }`;

  if (inline) {
    return (
      <div className="custom-loader-inline">
        <div className="custom-loader-content">
          <div className={spinnerClass} role="status">
            <span className="visually-hidden"></span>
          </div>
          {text && <p className={textClass}>{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="custom-loader-wrapper">
      <div className="custom-loader-content">
        <div className={spinnerClass} role="status">
          <span className="visually-hidden"></span>
        </div>
        <p className={textClass}>{text}</p>
        <div className="custom-loader-subtext">
          Please wait while we process your request
        </div>
      </div>
    </div>
  );
}

export default Loader;
